var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapMarkerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-10%",
    y: "-5%",
    width: "120%",
    height: "120%",
    filterUnits: "objectBoundingBox",
    id: "4a84ow9jna"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.172612544 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20 10.119c-.066 5.522-4.596 9.946-10.118 9.88C4.359 19.933-.064 15.404 0 9.881.066 4.359 4.597-.065 10.119.001c5.523.065 9.946 4.596 9.88 10.118",
    id: "4xi6d4i8gb"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#4a84ow9jna)",
    xlinkHref: "#4xi6d4i8gb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#4xi6d4i8gb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.608 13.813c.42.524.847 1.182 1.07 1.58.273.518.385.868.588 1.49.119.343.23.447.468.447.259 0 .378-.174.469-.447.189-.588.335-1.035.566-1.462.455-.818 1.028-1.545 1.588-2.244.154-.196 1.133-1.35 1.573-2.266 0 0 .539-1 .539-2.399 0-1.307-.532-2.217-.532-2.217l-1.538.413-.937 2.462-.231.335-.05.063-.062.077-.105.126-.154.154-.832.678-2.077 1.203-.343 2.007z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.462 10.743c.51 1.16 1.482 2.175 2.146 3.07l3.518-4.168s-.497.65-1.392.65c-1 0-1.81-.797-1.81-1.804 0-.692.412-1.168.412-1.168L6.95 7.96l-.49 2.783z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.168 3.967a4.694 4.694 0 0 1 2.77 2.335l-2.812 3.35s.412-.482.412-1.168c0-1.028-.867-1.804-1.804-1.804-.888 0-1.398.643-1.398.643V5.212l2.832-1.245z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.105 5.442c.7-.832 1.923-1.692 3.615-1.692.818 0 1.44.217 1.44.217L9.337 7.323h-2l-.231-1.88z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.462 10.743S6 9.827 6 8.505c0-1.252.49-2.342 1.112-3.056l2.23 1.881-2.88 3.413z",
    fill: "#EA4335"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerIcon);
export default __webpack_public_path__ + "static/media/map-marker-icon.2b2757a08bdf4eda3cc9ba383fbd2858.svg";
export { ForwardRef as ReactComponent };